/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../shared/images/teambuildr-selection.json';
import getAllUrlParams from '../../shared/utils/getAllUrlParams';
import Header from './components/presentational/Header';
import CalendarContent from './components/presentational/CalendarContent';

const BANNER_KEY = 'tb_calendar_info_banner_dismissed';

const PageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.hideNav || props.viewType === 'weekView' ? '0px' : '49px')};
  padding-top: ${(props) => (!props.hideNav && props.viewType === 'weekView' ? '49px' : '')};
  height: ${(props) => (props.hideNav || props.viewType === 'weekView' ? '100%' : 'calc(100% - 49px)')};
  width: 100%;
  background: #F5F5F5;
`;

const IconSideBarAndContentWrapper = styled('div')`
  display: flex;
  position: relative;
  height: ${(props) => (props.viewType === 'weekView'
    ? '100%'
    : props.headerHeight
      ? `calc(100% - ${props.headerHeight}px)`
      : 'calc(100% - 61.5px)')};
  padding-top: ${(props) => (props.viewType === 'weekView' ? `${props.headerHeight}px` : '')};
  ${(props) => props.viewType === 'weekView' && 'min-width: fit-content;'}
`;

const InfoBanner = styled('div')`
  position: fixed;
  top: ${(props) => (props.hideNav ? '87px' : '136px')};
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px 12px 16px;
  background: #FFFBEB;
  border: 2px solid #FFCB47;
  border-radius: 8px;
  color: #333333;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  white-space: nowrap;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: 767px) {
    white-space: normal;
    width: calc(100vw - 32px);
  }
`;

const BannerDismiss = styled('button')`
  background: none;
  border: none;
  cursor: pointer;
  color: #1787FB;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 0;
  margin-left: 8px;
  flex-shrink: 0;
  transition: opacity 150ms ease-in-out;
  &:hover {
    opacity: 0.7;
  }
`;

const CalendarLayout = () => {
  const [bannerDismissed, setBannerDismissed] = useState(
    () => localStorage.getItem(BANNER_KEY) === 'true',
  );
  const headerHeight = useSelector((state) => state.calendar.data.headerHeight);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const urlParams = getAllUrlParams(window.location.href, false);
  const hideNav = urlParams.hideNav === 'true';

  const handleDismissBanner = () => {
    setBannerDismissed(true);
    localStorage.setItem(BANNER_KEY, 'true');
  };

  return (
    <PageWrapper viewType={viewType} hideNav={hideNav}>
      <Header />
      {!bannerDismissed && (
        <InfoBanner hideNav={hideNav}>
          <IcomoonReact iconSet={iconSet} size={18} icon='warning' color='#F59E0B' />
          You can build in either Calendar or Build (Beta) — both are &ldquo;live&rdquo; and publish to the same athletes and calendars.
          <BannerDismiss onClick={handleDismissBanner} aria-label='Dismiss banner'>
            Understood
          </BannerDismiss>
        </InfoBanner>
      )}
      <IconSideBarAndContentWrapper headerHeight={headerHeight} viewType={viewType}>
        <CalendarContent />
      </IconSideBarAndContentWrapper>
    </PageWrapper>
  );
};

export default CalendarLayout;
